<div class="filter-btn" [class]="props.class">
    <img [src]="props.img" alt="filter" />
</div>
